import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BookingProvider } from './context/BookingContext';
import Navbar from './components/Navbar';
import Features from './pages/Features';
import BookingSystem from './pages/BookingSystem';
import Calendar from './pages/Calendar';
import CourtManagement from './pages/CourtManagement';
import BookingConfirmation from './pages/BookingConfirmation';
import OwnerDashboard from './pages/OwnerDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import MobileToast from './components/MobileToast';

function App() {
  return (
    <AuthProvider>
      <BookingProvider>
        <BrowserRouter>
          <div className="min-h-screen app-background flex flex-col">
            <Navbar />
            <div className="flex-1 container mx-auto p-4 pb-20">
              <Routes>
                <Route path="/" element={<Features />} />
                <Route path="/book" element={<BookingSystem />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/manage" element={<ProtectedRoute><CourtManagement /></ProtectedRoute>} />
                <Route path="/confirm" element={<BookingConfirmation />} />
                <Route path="/owner" element={<ProtectedRoute><OwnerDashboard /></ProtectedRoute>} />
              </Routes>
            </div>

            {/* Mobile Toast - appears when content wraps */}
            <MobileToast targetSelector=".container" threshold={20} />

            {/* Copyright Footer */}
            <footer className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white text-center py-2 text-xs z-30">
              <div className="container mx-auto">
                <p>© 2026 PicklePro. All rights reserved. | <span className="text-gray-400">facilityva.support</span></p>
              </div>
            </footer>
          </div>
        </BrowserRouter>
      </BookingProvider>
    </AuthProvider>
  );
}

export default App;